import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex h-full w-full items-center justify-center" }
const _hoisted_2 = {
  class: "grid grid-cols-2 gap-6",
  style: {"grid-template-columns":"auto min-content"}
}
const _hoisted_3 = { class: "pb-3 pt-10" }
const _hoisted_4 = { class: "relative items-center py-4" }
const _hoisted_5 = {
  key: 0,
  class: "error-message text-sm text-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_map_location_selector = _resolveComponent("map-location-selector")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    "have-modal": _ctx.haveModal,
    "is-displayed": _ctx.isEditModalOpened,
    "is-select-modal": true,
    "no-padding": true,
    title: "Asset details",
    onToggleModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      (_ctx.isMapLocationModalOpened)
        ? (_openBlock(), _createBlock(_component_map_location_selector, {
            key: 0,
            "coordinates-prop": {
        lat: _ctx.deviceAssignment.latitude,
        lng: _ctx.deviceAssignment.longitude,
      },
            "is-map-location-modal-opened": _ctx.isMapLocationModalOpened,
            onToggleModal: _ctx.toggleMapLocationModal,
            onGetCoordinates: _ctx.getMarkerCoordinates
          }, null, 8, ["coordinates-prop", "is-map-location-modal-opened", "onToggleModal", "onGetCoordinates"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_form_wrapper, {
          "is-form-in-modal": _ctx.isFormInModal,
          "is-loading": _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
            }, [
              _createVNode(_component_form_divider, null, {
                default: _withCtx(() => [
                  _createVNode(_component_input_field, {
                    modelValue: _ctx.deviceAssignment.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deviceAssignment.name) = $event)),
                    errorMessage: _ctx.v$?.deviceAssignment['name']?.$errors[0]?.$message,
                    isError: _ctx.v$?.deviceAssignment['name']?.$error,
                    required: true,
                    label: "Name",
                    placeholder: "Enter device name..."
                  }, null, 8, ["modelValue", "errorMessage", "isError"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_input_field, {
                        modelValue: _ctx.deviceAssignment.latitude,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deviceAssignment.latitude) = $event)),
                        label: "Latitude"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_input_field, {
                        modelValue: _ctx.deviceAssignment.longitude,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deviceAssignment.longitude) = $event)),
                        label: "Longitude"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_the_button, {
                        icon: ['fas', 'earth-europe'],
                        "button-type": "primaryButton",
                        type: "button",
                        onExecuteMethod: _ctx.toggleMapLocationModal
                      }, null, 8, ["onExecuteMethod"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Group", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.deviceAssignment.applicationId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.deviceAssignment.applicationId) = $event)),
                      class: _normalizeClass([`mt-1 border ${
                  _ctx.v$.deviceAssignment['applicationId']?.$error
                    ? 'rounded-md border-error'
                    : 'border-none'
                }`, "mt-1"]),
                      options: _ctx.applications.items,
                      reduce: (spot) => spot.id,
                      label: "name"
                    }, null, 8, ["modelValue", "class", "options", "reduce"]),
                    (_ctx.v$.deviceAssignment['applicationId']?.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.v$?.deviceAssignment["applicationId"]?.$errors[0]?.$message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isLoadingSubmit }, null, 8, ["is-submit-loading"])
            ], 32)
          ]),
          _: 1
        }, 8, ["is-form-in-modal", "is-loading"])
      ])
    ]),
    _: 1
  }, 8, ["have-modal", "is-displayed"]))
}